import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntBorderedBadgeComponent} from "./int-bordered-badge.component";

@NgModule({
  imports: [CommonModule],
  declarations: [IntBorderedBadgeComponent],
  exports: [IntBorderedBadgeComponent]
})
export class IntBorderedBadgeModule {}
